import React from 'react'
import { useSelector } from 'react-redux'
import { docsUrlSelector } from '../auth/authSelectors'

const Docs: React.FC = () => {
  const docsUrl = useSelector(docsUrlSelector)

  return (
    <iframe
      src={docsUrl}
      title="Foresight Documentation"
      style={{ width: '100%', height: 'calc(100vh - 170px)', border: 'none' }}
    />
  )
}

export default Docs
